import AddNewAccountantModal from 'admin/features/accountants/accountantsModals/AddNewAccountantModal';
import { LoginIcon, SignUpIcon } from 'assets/icons';
import { CustomButton } from 'Components/Auth/CustomButton';
import useCreateModal from 'Components/Popups/useCreateModal';
import { Outlet, useLocation } from 'react-router';
import { Link } from 'react-router-dom';

export interface IAuthLayoutProps {}

export default function AuthLayout(props: IAuthLayoutProps) {
  const { pathname } = useLocation();
  const AccountantSignupModal = useCreateModal();
  const isLogin = pathname === '/login';

  return (
    <div>
      <div
        className="relative rounded-t-4xl"
        style={{
          minHeight: 'calc(100vh - 72px',
        }}
      >
        <div
          style={{
            minHeight: 'calc(100vh - 72px',
            boxShadow: '0px 10px 20px #8D8D8D14 inset',
          }}
          className="bg-gray-300 h-full xs:w-full w-1/2 inset-y-0 left-0 flex rounded-tl-4xl justify-center md-max:w-full"
        >
          <Outlet />
        </div>
        <div className="md-max:w-0 md-max:overflow-x-hidden  absolute rounded-tr-4xl bg-green bg-opacity-90 w-1/2 inset-y-0 right-0 flex justify-center items-center flex-col xs:hidden sm:flex md:flex lg:flex">
          <h1 className="text-xl text-white   mb-3 font-bold">
            Hire the Best Tax Experts
          </h1>
          <p className="text-regular text-white lg:mx-40 text-center font-normal leading-7 tracking-wide mb-10">
            Many companies use Accountants On Air to do their
            <br /> business and to turn their dreams into reality
          </p>
          <div className="w-2/5">
            <Link to={isLogin ? '/sign-up' : '/login'}>
              <CustomButton
                borderColor="white"
                text={isLogin ? ' Sign Up' : 'Log In'}
                suffix={isLogin ? <SignUpIcon /> : <LoginIcon />}
                opacity={0}
              />
            </Link>
          </div>

          <p className="text-regular font-bold text-white lg:mx-40 text-center leading-7 tracking-wide mt-20 mb-5">
            Are you an accountant?
          </p>
          <div className="w-2/5">
            <CustomButton
              onClick={AccountantSignupModal.open}
              borderColor="white"
              text={'Sign Up as an accountant'}
              suffix={<SignUpIcon />}
              opacity={0}
            />
            <AccountantSignupModal.Component>
              <AddNewAccountantModal />
            </AccountantSignupModal.Component>
          </div>
        </div>
      </div>
    </div>
  );
}
